module.exports = __webpack_public_path__ + "img/leadCancelled.35ae8f56.svg";